export const HOME = '/';
export const OVERVIEW = '/oversikt';
export const PLAYTOGETHER = '/spela-tillsammans';
export const LEARNING = '/utbildning';
export const TIPS_INSPIRATION = '/tips-inspiration';
export const PRODUCTOVERVIEW = '/produkter';
export const PRODUCT = '/produkter/:tenantPath';
export const PRODUCTPAGE = '/produkter/:tenantPath/:path';